/**
 * Build a consulting lead's `source` map from the landing URL + referrer,
 * so every submission traces back to the content item that drove the click
 * (GOAL.md pillar 6). Pure function — no window/document access — so it's
 * unit-testable and reusable outside the page component.
 * @param {string} search - window.location.search (may be '')
 * @param {string} referrer - document.referrer (may be '')
 */
export function buildLeadSource(search, referrer) {
  const params = new URLSearchParams(search || '');
  const source = {
    utmSource: params.get('utm_source') || null,
    utmMedium: params.get('utm_medium') || null,
    utmCampaign: params.get('utm_campaign') || null,
    utmContent: params.get('utm_content') || null,
    referrer: referrer || null,
  };
  // A human-readable rollup for quick scanning in the console/admin list.
  source.summary = source.utmSource
    ? `${source.utmSource}${source.utmCampaign ? ` / ${source.utmCampaign}` : ''}`
    : referrer
      ? `referral: ${referrer}`
      : 'direct';
  return source;
}
